<script setup lang="ts">
import { watch } from 'vue'
import { useFeedback } from '~/shared/composables'
import { useUiStore } from '~/stores/ui'

/**
 * Drains the UI store's notice queue into Naive's message API.
 *
 * It exists because `useMessage` only works inside a component under `n-message-provider`, and
 * the things that most need to say something — a router guard turning a user away from a
 * workspace, the HTTP interceptor discovering the session is gone — are neither. They queue;
 * this renders. Nothing is displayed by this component itself.
 */
const ui = useUiStore()
const feedback = useFeedback()

watch(
  () => ui.notices.length,
  (count) => {
    if (count === 0) return
    for (const notice of ui.takeNotices()) {
      if (notice.type === 'success') feedback.success(notice.text)
      else if (notice.type === 'error') feedback.error(notice.text)
      else feedback.info(notice.text)
    }
  },
)
</script>

<template><span /></template>
